import { useEffect } from 'react';
import { useListSignupCountriesQuery } from '../store/api/signupApi';
import { registrarMonedas } from '../utils/moneda';

/**
 * Carga el catálogo de monedas (símbolo y decimales por código) una vez por sesión y lo
 * deja registrado para `formatMoney` / `simboloDe`, que son funciones puras y se llaman
 * desde cualquier lado — tarjetas, PDFs, tooltips — sin pasar por un hook.
 *
 * Usa el endpoint PÚBLICO de países del alta: sirve igual para la vidriera sin login.
 * No renderiza nada.
 */
export function MonedasCatalogoLoader() {
  const { data } = useListSignupCountriesQuery();
  useEffect(() => {
    if (data?.length) registrarMonedas(data);
  }, [data]);
  return null;
}
